export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-shape/src/constant.js
// module id = ../../../../d3-shape/src/constant.js
// module chunks = vendor